module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    staticClass: "spinner-container"
  }, [_c('spinner', {
    staticClass: "spinner-secction"
  })], 1) : _c('tabs', [_c('tab', {
    attrs: {
      "name": "Reports",
      "selected": true
    }
  }, [_c('DocumentView', {
    attrs: {
      "documents": _vm.reports,
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Monthly Statements"
    }
  }, [_c('DocumentView', {
    attrs: {
      "documents": _vm.monthlys,
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Tax Documents"
    }
  }, [_c('DocumentView', {
    attrs: {
      "documents": _vm.taxes,
      "user": _vm.user
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Transaction Notices"
    }
  }, [_c('DocumentView', {
    attrs: {
      "documents": _vm.transactionNotices,
      "user": _vm.user
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b0451dd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentTabView/DocumentTabView.vue
// module id = 2181
// module chunks = 1